import moment from 'moment';
import { FC, memo } from 'react';
import { DomainEntitiesExchangeRateSource } from 'shared/data/webApp/v2';
import { getExchangeRateSourceName } from 'shared/helpers/exchangeRate';

import { useExchangeRateWithUpdate } from './ExchangeRateWithUpdate.hooks';
import { messages } from './ExchangeRateWithUpdate.messages';
import { Root } from './ExchangeRateWithUpdate.styles';
import { ExchangeRateWithUpdateProps } from './ExchangeRateWithUpdate.types';

export const ExchangeRateWithUpdate: FC<ExchangeRateWithUpdateProps> = memo((props) => {
    const { className, isXero, companyCurrency } = props;

    const { currencyExchangeRate, dateParam } = useExchangeRateWithUpdate(props);

    if (!currencyExchangeRate) {
        return null;
    }

    const sourceName = getExchangeRateSourceName(currencyExchangeRate.source);

    const showXeroSyncDisclaimer = isXero && currencyExchangeRate.source !== DomainEntitiesExchangeRateSource.Xero;

    return (
        <Root className={className}>
            {messages.exchangeRateText({
                currency: currencyExchangeRate.isoCode,
                baseCurrency: companyCurrency,
                rate: currencyExchangeRate.exchangeRate,
            })}

            <span>{` (${moment.utc(dateParam).format('ll')}, ${sourceName})`}</span>

            {showXeroSyncDisclaimer && (
                <span>
                    {'. '}

                    {messages.xeroSyncDisclaimer}
                </span>
            )}
        </Root>
    );
});

ExchangeRateWithUpdate.displayName = 'ExchangeRateWithUpdate';
